import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateUserGroup = () => {
  const queryClient = useQueryClient();
   const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (input) => {
      const result = await restClient({
        url: `${prefix}/user-groups`,
        method: 'POST',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch user groups list after successful creation
      queryClient.invalidateQueries(['userGroups']);
    }
  });
};
